import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-allowance',
  templateUrl: './allowance.component.html',
  styleUrls: ['./allowance.component.css']
})
export class AllowanceComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "Allowance";

  filterstatus: string = "ALL";
  allowanceColl: any = [];


  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Earning', field: 'allowancename' },
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
    pageindex:1
  };
  constructor(private appService: AppdataService, public loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private productFindService: NgbModal,) {
    this.route.queryParams.subscribe(params => {
      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
    })

    this.fnServiceChanges();
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {

      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetAllowance();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
 
  //Event  
  fnActionEditClick(data) {
    
    if (!this.isedit) {
      return;
    }
   

      if (data.isdefault) {
        this.confirmationDialogService.confirm('Info..', 'Cannot Edit/Delete system default records ', "", "INFO");
        return;
      }

      this.fnEditForm(data.allowanceid);

    }
   

  fnActionDeleteClick(data) {
   

    if (!this.isdelete) {
      return;
    }
   

      if (data.isdefault) {
        this.confirmationDialogService.confirm('Info..', 'Cannot Edit/Delete system default records ', "", "INFO");
        return;
      }
      this.fnDeleteConfirm(data.allowanceid, data.allowancename);
    }
    

  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'allowancelist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
   // this.gridApi.exportDataAsCsv(params);
  }

  fnActionFilterClick() {

    this.filterbar.filterstatus = this.filterstatus;

    this.isfilter = !this.isfilter;
  }

  fnActionRefreshClick() {
    this.fngetAllowance()
  }

  fnApplyFilter(data) {
   // this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetAllowance();

  }

  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetAllowance();
    }
    else {
      this.filterstatus = "";
      this.fngetAllowance();
    }
  }


  //Get
  fngetAllowance() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();

    var data = {
      'allowanceid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus
    }
    this.appService.getAllowance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.allowanceColl = res.json().result;
            this.fnSetTable();
            this.fnCurrentRouteChange();
          } else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnAddForm() {
    try {
      this.router.navigate(['/AddAllowance']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditForm(deptid) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
        }
      }

      this.router.navigate(['/AddAllowance'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  public fnDeleteConfirm(deptid, reftxt) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete allowance?', reftxt)
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteForm(deptid, reftxt)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid, reftxt) {
    var data = {
      'allowanceid': deptid,
    }
    this.appService.fnDeleteAllowance(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The allowance has been deleted successfully.");
            this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetAllowance();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnSetTable() {
     
  }

  public fnSearchDatatable(value) {
    
  }
  fnResetGrid(data){
    this.searchtxt=data;
    this.gridOptions.pageindex=1
  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.allowanceColl[index].hoverfocus = "IN"
      }
      else {
        this.allowanceColl[index].hoverfocus = ""
      }
    }
  }
  
  fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.allowanceColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
